import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { toast } from 'react-toastify';
import { SelectTimeZone } from '../../features/SelectTimeZone/index.js';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField } from '../../shared/ui/FormLayout';

const CreateTimezonePage = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    offset: '',
    title: '',
    mainLanguageId: 1,
  });

  const handleSubmit = async () => {
    if (!form.title.trim()) { toast.error('Введите название'); return; }
    setSaving(true);
    try {
      await apiRequests.events.createTimezone({
        ...form,
        offset: form.offset.startsWith('+') ? form.offset.replace('+', '') : form.offset,
      });
      toast.success('Часовая зона создана');
      navigate('/events/timezones');
    } catch { toast.error('Ошибка'); } finally { setSaving(false); }
  };

  return (
    <FormLayout onSubmit={handleSubmit} onBack={() => navigate('/events/timezones')} saving={saving} submitText="Создать">
      <FormSection title="Основная информация">
        <Row>
          <Col md={4}>
            <FormField label="Заголовок" required>
              <Form.Control type="text" value={form.title} onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))} />
            </FormField>
          </Col>
          <Col md={4}>
            <FormField label="UTC">
              <SelectTimeZone onSelect={(val) => setForm((prev) => ({ ...prev, offset: val }))} />
            </FormField>
          </Col>
          <Col md={4}>
            <LanguageOptions onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))} />
          </Col>
        </Row>
      </FormSection>
    </FormLayout>
  );
};

export default CreateTimezonePage;
